<template>
    <div>
        <vButtonGroup
            class="inbound-package"
            style="margin-bottom: 15px; margin-top: 10px"
        >
            <vButton class="light-content" @click="addnotes">{{
                $t("boss.purchase.add_note", { defaultValue: "添加备注" })
            }}</vButton>
            <vButton theme="info" @click="fixDate">{{
                $t("boss.purchase.modify_the_expected", {
                    defaultValue: "修改预计验货日期",
                })
            }}</vButton>
        </vButtonGroup>
        <compWrapper
            :title="
                $t('boss.purchase.enter_inspection_data', {
                    defaultValue: '录入验货',
                })
            "
            theme="primary"
        >
            <compFormEdit
                class="margin-top-15 margin-right-15"
                ref="supplierEditForm"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            >
            </compFormEdit>
        </compWrapper>
        <compWrapper
            :title="
                $t('boss.purchase.attachment_information', {
                    defaultValue: '附件信息',
                })
            "
            theme="success"
        >
            <vButton
                class="margin-left-15 margin-top-15"
                theme="info"
                @click="adddocument"
                >{{
                    $t("boss.purchase.add_attachment", {
                        defaultValue: "添加附件",
                    })
                }}</vButton
            >
            <vTable
                class="margin-15"
                :columns="doccolumns"
                :data="docList"
                size="small"
                ref="tablequery"
                border
            ></vTable>
        </compWrapper>
        <compWrapper
            :title="
                $t('boss.purchase.inspection_record', {
                    defaultValue: '验货记录',
                })
            "
            theme="gray"
        >
            <vTable
                class="margin-15"
                :columns="salecolumns"
                :data="salelist"
                size="small"
                ref="tablequery"
                border
            ></vTable>
        </compWrapper>
        <div class="text-right">
            <vButton class="margin-right-20" theme="primary" @click="submit">{{
                $t("boss.purchase.save", { defaultValue: "保存" })
            }}</vButton>
            <vButton class="margin-right-20" @click="cancel">{{
                $t("boss.purchase.cancel", { defaultValue: "取消" })
            }}</vButton>
        </div>

        <compModal
            v-model="handle.show"
            v-bind="handle"
            @on-close="handle = {}"
        >
            <component
                ref="cusref"
                :is="handle.component"
                v-bind="handle"
                v-on="handle.on"
            ></component>
            <!-- <footer slot="footer" v-show="false"></footer> -->
        </compModal>
    </div>
</template>

<script>
import {
    HttpDelAttach,
    HttpDelAttachNew,
    HttpGetExpectedInspectDate,
    HttpConfirmInspect,
    HttpGetInspectByPoId,
    HttpGetOrderNotes,
    HttpGetOrderOne,
} from "@/service/purchase/purchase";
export default {
    props: ["activeid"],
    data() {
        return {
            id: this.$route.query.id || this.activeid,
            formData: {
                inspectStatus: 1,
            },
            docList: [],
            salelist: [],
            handle: {
                show: false,
                title: "",
                component: null,
            },
        };
    },
    created() {
        this.update();
    },
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compUpload: () => import("@components/templates/upload"),
        compMutiUpload: () => import("@components/templates/mutiUpload"),
        compModal: () => import("@components/templates/modal"),
    },
    computed: {
        getBase() {
            return [
                {
                    label: this.$t("boss.purchase.expected_inspection_date", {
                        defaultValue: "预计验货日期",
                    }),
                    key: "expectedDate",
                    tag: "vInput",
                    query: true,
                },
                {
                    label: this.$t("boss.purchase.inspection_results", {
                        defaultValue: "验货结果",
                    }),
                    key: "inspectStatus",
                    tag: "vRadio",
                    props: {
                        strict: false,
                    },
                    options: [
                        {
                            trueValue: 1,
                            label: this.$t("boss.purchase.qualified", {
                                defaultValue: "合格",
                            }),
                        },
                        {
                            trueValue: 2,
                            label: this.$t("boss.purchase.unqualified", {
                                defaultValue: "不合格",
                            }),
                        },
                    ],
                },
                {
                    label: this.$t("boss.purchase.actual_inspection_date", {
                        defaultValue: "实际验货日期",
                    }),
                    key: "inspectDate",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm-dd",
                    },
                },
                {
                    label: this.$t("boss.purchase.inspection_personnel", {
                        defaultValue: "验货人",
                    }),
                    key: "inspectPersonName",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                    tag: "vTextarea",
                    required: false,
                },
            ];
        },
        doccolumns() {
            let _this = this;
            return [
                {
                    title: this.$t("boss.purchase.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.attachment_link", {
                        defaultValue: "附件链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                    style: {
                                        "margin-right": "15px",
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downfile(row.attachUrl);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
        salecolumns() {
            return [
                {
                    title: this.$t("boss.purchase.inspection_date", {
                        defaultValue: "验货日期",
                    }),
                    key: "inspectDate",
                },
                {
                    title: this.$t("boss.purchase.inspection_results", {
                        defaultValue: "验货结果",
                    }),
                    key: "inspectStatus",
                    render: (h, { row }) => {
                        return (
                            <div>
                                {row.inspectStatus == 1
                                    ? this.$t("boss.purchase.qualified", {
                                          defaultValue: "合格",
                                      })
                                    : this.$t("boss.purchase.unqualified", {
                                          defaultValue: "不合格",
                                      })}
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("boss.purchase.inspection_personnel", {
                        defaultValue: "验货人",
                    }),
                    key: "inspectPersonName",
                },
                {
                    title: this.$t("boss.purchase.notes", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                },
            ];
        },
    },

    methods: {
        addnotes() {
            this.handle = {
                show: true,
                alert: "primary",
                title: this.$t("boss.purchase.add_note", {
                    defaultValue: "添加备注",
                }),
                width: 460,
                showDesc: false,
                params: { id: this.id },
                formdata: [
                    {
                        tag: "vTextarea",
                        key: "remark",
                        span: 24,
                        label: this.$t("boss.purchase.reason_remark", {
                            defaultValue: "备注原因",
                        }),
                    },
                ],
                ajaxRequest: HttpGetOrderNotes,
                callback: () => {
                    this.handle.show = false;
                    this.update();
                },
            };
        },
        fixDate() {
            let exdate = this.formData.expectedDate;
            this.handle = {
                show: true,
                alert: "primary",
                title: this.$t("boss.purchase.modify_the_expected", {
                    defaultValue: "修改预计验货日期",
                }),
                width: 460,
                showDesc: false,
                params: { id: this.id },
                formdata: [
                    {
                        label: this.$t(
                            "boss.purchase.original_estimated_inspection_date",
                            {
                                defaultValue: "原始预计验货日期",
                            }
                        ),
                        valueText: exdate,
                        span: 24,
                        query: true,
                    },
                    {
                        label: this.$t(
                            "boss.purchase.new_estimated_inspection_date",
                            {
                                defaultValue: "新预计验货日期",
                            }
                        ),
                        tag: "vDatepicker",
                        key: "expectedInspectDate",
                        span: 24,
                        props: {
                            format: "yyy-mm-dd",
                        },
                    },
                ],
                ajaxRequest: HttpGetExpectedInspectDate,
                callback: () => {
                    this.handle.show = false;
                    this.update();
                },
            };
        },
        update() {
            HttpGetOrderOne({
                id: this.id,
            }).then((res) => {
                // console.log(res.data.expectedInspectDate)
                this.$set(
                    this.formData,
                    "expectedDate",
                    res.data.expectedInspectDate
                );
            });
            HttpGetInspectByPoId({
                poId: this.id,
            }).then(
                (res) => {
                    this.salelist = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        adddocument() {
            this.handle = {
                show: true,
                title: this.$t("boss.purchase.add_attachment", {
                    defaultValue: "添加附件",
                }),
                width: 460,
                component: "compMutiUpload",
                data: {
                    srcLabel: this.id || 0,
                    model: "po_order_inspect",
                    type: "other",
                },
                showFooter: false,
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                multiple: true,
                on: {
                    "on-success": (res) => {
                        console.log(res);
                        let flag = false;
                        if (res.items.length + this.docList.length > 5) {
                            this.$VMessage.error(
                                this.$t("boss.purchase.package_and_upload", {
                                    defaultValue: "附件数量过多，请打包后上传",
                                })
                            );
                            flag = true;
                        }
                        res.items.map((item) => {
                            if (flag) {
                                this.remove(item.attachId, true);
                            } else {
                                this.docList.push(item);
                            }
                        });
                        this.handle = {};
                    },
                    "on-cancel": () => {
                        this.handle = {};
                    },
                },
            };
        },
        downfile(url) {
            this.handleWebfs(url, {}, "download");
        },
        remove(index, useId) {
            // 新增时删除附件用另外的接口
            HttpDelAttachNew({
                id: useId ? index : this.docList[index].attachId,
            }).then(
                (res) => {
                    if (!useId) {
                        this.docList.splice(index, 1);
                        this.$VMessage.success(res.message);
                    }
                },
                (err) => {
                    if (!useId) {
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                }
            );
        },
        async submit() {
            let valid = await this.$refs["supplierEditForm"].validate();
            if (!valid) return;
            HttpConfirmInspect({
                id: this.id,
                ...this.formData,
                meta: JSON.stringify({
                    items: this.docList,
                    opAt: this.docList[0] ? this.docList[0].attachOpAt : "",
                    organizationId: global.SYSID,
                }),
            }).then(
                (res) => {
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            this.$emit("on-close");
            // this.$router.push({
            //     name: "purchaseOrderList",
            // });
        },
    },
};
</script>
